<template>
    <div>
        <br/>There are 12 types of wonderous Items:
        <v-row>           
            <v-col sm="4">  
                <ul>
                    <li><a @click="scrollTo('ring')" >Ring</a></li>
                    <li><a @click="scrollTo('neck')" >Neck</a></li>
                    <li><a @click="scrollTo('eyes')" >Eyes</a></li>
                    <li><a @click="scrollTo('belt')" >Belt</a></li>
                    <li><a @click="scrollTo('hands')" >Hands</a></li>
                    <li><a @click="scrollTo('wrist')" >Wrist</a></li>
                    <li><a @click="scrollTo('untyped')" >Untyped</a></li>
                </ul>
            </v-col>
            <v-col>
                <ul>
                    <li><a @click="scrollTo('head')" >Head</a></li>
                    <li><a @click="scrollTo('shoulders')" >Shoulders</a></li>
                    <li><a @click="scrollTo('chest')" >Chest</a></li>
                    <li><a @click="scrollTo('headband')" >Headband</a></li>
                    <li><a @click="scrollTo('body')" >Body</a></li>
                    <li><a @click="scrollTo('feet')" >Feet</a></li>
                </ul>
            </v-col>
            <v-col sm="4">
                There are 5 rarities:
                <ul>
                    <li>Common</li>
                    <li>Rare</li>
                    <li>Epic</li>
                    <li>Legendary</li>
                    <li>Unique</li>
                </ul>
            </v-col>
        </v-row>
        <br/><br/>
        <div v-for="type in types" :key="type">
            <h2 :id="type" style="color:cornflowerblue">{{filterString(type)}}:</h2>
            <div v-for="rarity in rarities" :key="rarity">
                <h3>{{rarity[0].toUpperCase() + rarity.substr(1)}}:</h3>
                <table style="width:100%">
                    <tr> 
                        <th>Name</th>
                        <th>Type</th>
                        <th>Description</th>
                    </tr>
                    <tr v-for="item in sortedItems(type, rarity)" :key="item.name"> 
                        <td style="text-align:center">{{item.name}}</td>
                        <td style="padding-left:4px; padding-right:4px">{{item.type[0]}}<span v-if="item.type[1]">, {{item.type[1]}}</span></td>
                        <td style="padding-left:4px; padding-right:4px">{{item.longDesc}}</td>
                    </tr>
                </table>           
                <br/>
        </div> 
    </div>
    <v-icon style="position:fixed; right:16px; bottom:16px; color:cornflowerblue" outlined large @click="scrollTo('top')">mdi-arrow-up-circle</v-icon>
    </div>
</template>
<script>
//
import {wonderousItems} from "../../../play/data"

export default {
  components: {
  },
  props:{
  },
  mounted(){
  },
  data(){
      return{
          types:['ring', 'neck', 'eyes', 'belt', 'hands', 'wrist', 'head', 'shoulders','chest','headband', 'body', 'feet','untyped'],
          rarities:["common","rare","epic","legendary","unique"],
      }
  },
  methods:{
      sortedItems(type,rarity){
        let allItems = [...wonderousItems]
        let sortedItems = allItems.filter(item=>item.type.includes(type) && item.rarity == rarity)        
        let sorted = sortedItems.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        sorted = sorted.filter((value, index, self) =>
        index === self.findIndex((t) => (t.name === value.name)))
        return sorted
      },
      scrollTo(id){
        if(id == 'top'){
            window.scrollTo({top: 0, behavior: 'instant'});
        }else{
            let section = document.getElementById(id)
            section.scrollIntoView({behavior: "smooth"})
        }
      },    
      filterString(str){
          let remove = str.replace("Handed"," Handed")
          let newStr = remove[0].toUpperCase() + remove.substring(1)
          return newStr

      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>